export default {
  nav: {
    home: 'Accueil',
    shoppingGuide: "Guide d'achat",
    categories: 'Catégories',
    guides: 'Guides',
    review: 'Avis',
    shipping: 'Livraison',
    safety: 'Sécurité',
    articles: 'Articles',
    cta: 'Acheter',
  },
  footer: {
    disclaimerTitle: 'Avertissement important',
    disclaimer: "Ceci est un site de ressources indépendant, non affilié à AllChinaBuy ni à aucune plateforme associée. Toutes les marques appartiennent à leurs propriétaires respectifs.",
    safety: 'Sécurité',
    privacy: 'Confidentialité',
    terms: 'Conditions',
    about: 'À propos',
    copyright: 'Tous droits réservés.',
  },
  notFound: {
    title: 'Page introuvable',
    subtitle: 'La page que vous recherchez n\'existe pas.',
    backHome: 'Retour à l\'accueil',
  },
};